import {
    Box,
    Button,
    Card,
    CardContent,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Popover,
    Select,
    SelectChangeEvent,
    SxProps,
    TextField,
    Typography,
    useTheme,
} from '@mui/material';
import FilterIcon from '@mui/icons-material/Tune';
import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import CancelIcon from '@mui/icons-material/Cancel';
import ShareIcon from '@mui/icons-material/Share';
import { Option } from 'src/features/autocomplete/types';
import { autocompleteEndpoint, getLeadFilterEndpoint } from 'src/configs/endpoints';
import { Filter } from '../../../../features/filters/FilterTypes';
import { client } from '../../../../utils/axios-client';
import SprintStore from '../../../../stores/SprintStore';
import SimpleDialog from '../../../../features/common/SimpleDialog';
import SectionAppBar from '../../../components/Section/SectionAppBar';
import useReportSelector from './ReportSelector.hooks';
import { Report } from './ReportSelector.hooks';

type Props = {
    searchTerm: string;
    onSearchTermChanged: (value: string) => void;
    onSave: () => void;
    onSaveAs: () => void;
    onClearFilter: () => void;
    onShareFilter: () => void;
    hideShare?: boolean;
    hideSave?: boolean;
    children: React.ReactNode;
    savedFilters: Option[];
    savedFilterId: string;
    onFiltersChanged: (updatedDilter: Filter) => void;
    sx?: SxProps;
    filterLabel?: string;
    selectedReport: string;
    handleReportChange: (event: SelectChangeEvent<string>) => void;
    reports: Report[];
};

const FilterSearchComponent = ({
    children,
    searchTerm,
    hideSave,
    onSearchTermChanged,
    sx,
    onSave,
    onSaveAs,
    onClearFilter,
    onShareFilter,
    savedFilters,
    savedFilterId,
    onFiltersChanged,
    selectedReport,
    handleReportChange,
    reports,
    hideShare = false,
    filterLabel = 'Existing Filters',
}: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [open, setOpen] = React.useState(false);
    const ref = React.useRef(null);
    const theme = useTheme();
    const [age, setAge] = React.useState('');

    React.useEffect(() => {
        if (ref.current) setAnchorEl(ref.current);
    }, [ref.current]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event: SelectChangeEvent) => {
        setAge(event.target.value as string);
    };

    const loadFilter = async (id: string) => {
        const response2 = await client.get(getLeadFilterEndpoint.replace('{id}', id));

        SprintStore.update((s) => {
            s.leadFilters = response2.data;
        });

        onFiltersChanged(response2.data);
    };

    return (
        <Grid container sx={sx} ref={ref}>
            <Grid item xs={12}>
                <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel id="report-select-label">Select Report</InputLabel>
                    <Select
                        labelId="report-select-label"
                        value={selectedReport}
                        onChange={handleReportChange}
                        endAdornment={
                            <InputAdornment position="end">
                                {/*<FormControl size="small">*/}
                                {/*    <InputLabel id="filter-label">{filterLabel}</InputLabel>*/}
                                {/*    <Select*/}
                                {/*        labelId="filter-label"*/}
                                {/*        size="small"  label={filterLabel} onChange={(e) => loadFilter(e.target.value)} value={savedFilterId ?? ''}>*/}
                                {/*        {savedFilters.map(s => <MenuItem key={s.value} value={s.value.toLowerCase()}>{s.name}</MenuItem>)}*/}
                                {/*    </Select>*/}
                                {/*</FormControl>*/}
                                <FormControl fullWidth size="small" sx={{ width: 400 }}>
                                    <InputLabel
                                        id="filter-label"
                                        sx={{ backgroundColor: theme.palette.background.paper }}
                                    >
                                        {filterLabel}
                                    </InputLabel>
                                    <Select
                                        labelId="filter-label"
                                        id="filter-select"
                                        value={savedFilterId}
                                        label={filterLabel}
                                        onChange={(e) => loadFilter(e.target.value)}
                                    >
                                        {savedFilters.map((s) => (
                                            <MenuItem key={s.value} value={s.value.toLowerCase()}>
                                                {s.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <IconButton onClick={handleClick} edge="end" title="Additional filters">
                                    <FilterIcon />
                                </IconButton>
                                {!hideSave && (
                                    <IconButton onClick={onSave} edge="end" title="Save" sx={{ ml: 2 }}>
                                        <SaveIcon />
                                    </IconButton>
                                )}
                                {!hideSave && (
                                    <IconButton onClick={onSaveAs} edge="end" title="Save As" sx={{ ml: 2 }}>
                                        <SaveAsIcon />
                                    </IconButton>
                                )}
                                {!hideShare && (
                                    <IconButton onClick={onShareFilter} edge="end" title="Share Filter" sx={{ ml: 2 }}>
                                        <ShareIcon />
                                    </IconButton>
                                )}
                                {!hideSave && (
                                    <IconButton onClick={onClearFilter} edge="end" title="Clear Filter" sx={{ ml: 2 }}>
                                        <CancelIcon />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        }
                    >
                        {reports.map((report) => (
                            <MenuItem key={report.name} value={report.name}>
                                {report.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <SimpleDialog
                    open={open}
                    onClose={handleClose}
                    padding={0}
                    sx={{ backgroundColor: theme.palette.background.paper, height: '90%', maxHeight: '90%' }}
                >
                    <SectionAppBar
                        title="Filters"
                        subTitle=""
                        buttons={
                            <>
                                <Button variant="contained" size="small" onClick={() => setOpen(false)}>
                                    Close
                                </Button>
                            </>
                        }
                    />

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: theme.palette.background.paper,
                        }}
                        margin={2}
                        height="100%"
                    >
                        <Box height="100%" padding={4}>
                            {children}
                        </Box>
                    </Box>
                </SimpleDialog>
            </Grid>
        </Grid>
    );
};

export { FilterSearchComponent };
export default FilterSearchComponent;
